import { BoxProps, Box } from '@bitrise/bitkit';
import { HEADER_HEIGHT } from '@/constants';

type HeaderButtonProps = {
  isActive?: boolean;
  children: React.ReactNode;
} & BoxProps;

const HeaderButton = ({ isActive, children, ...props }: HeaderButtonProps): JSX.Element => (
  <Box
    as="button"
    display="flex"
    position="relative"
    alignItems="center"
    paddingX="12"
    gap="4"
    height={HEADER_HEIGHT}
    backgroundColor={isActive ? 'rgba(255, 255, 255, .2)' : 'transparent'}
    sx={{
      _hover: {
        backgroundColor: 'rgba(255, 255, 255, .1)',
      },
      _active: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
      _after: isActive
        ? {
            background: 'rgba(255, 255, 255, .8)',
            height: '4px',
            width: '100%',
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
          }
        : {},
    }}
    {...props}
  >
    {children}
  </Box>
);

export default HeaderButton;
